import { Paperclip, ExternalLink } from "lucide-react";
import { AnexoItem, AnexoInfo, AnexoNome, AnexoTamanho, AnexoLinkButton } from "../../styles";
import { AnexoOrientacaoCompleta } from "../../types";
import { truncarNomeArquivo } from "../../../../../../../../../utility/byteSizeUtils";
import toastservice from "../../../../../../../../../services/toast";

const FileXCorner = ({ size = 24, color = "currentColor" }: { size?: number; color?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M11 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v5"/>
        <path d="M14 2v5a1 1 0 0 0 1 1h5"/>
        <path d="m15 17 5 5"/>
        <path d="m20 17-5 5"/>
    </svg>
);

interface BlocoAnexosProps {
    anexos: AnexoOrientacaoCompleta[];
    onNavigateToFile?: (fileId: number) => void;
}

export default function BlocoAnexos({ anexos, onNavigateToFile }: BlocoAnexosProps) {
    if (!anexos || anexos.length === 0) {
        return null;
    }

    const handleClick = (id: number | null) => {
        if (!id || !onNavigateToFile) {
            return;
        }

        onNavigateToFile(id);
    };

    return (
        <div className="expanded-section">
            <h4 className="section-title">Anexos</h4>
            <div className="anexos-container">
                {anexos.map((anexo, indice) => {
                    const isExcluido = anexo.excluido === true;
                    return (
                        <AnexoItem 
                            key={anexo.id ?? `${anexo.nome}-${indice}`} 
                            style={{ 
                                opacity: isExcluido ? 0.75 : 1,
                                border: isExcluido ? '1px solid rgba(239, 68, 68, 0.3)' : undefined
                            }}
                            data-excluido={isExcluido ? "true" : "false"}
                        >
                            {isExcluido ? (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '16px', height: '16px' }}>
                                    <FileXCorner size={16} color="#EF4444" />
                                </div>
                            ) : (
                                <Paperclip size={16} color="#64748B" />
                            )}
                            <AnexoInfo>
                                <AnexoNome style={{ fontStyle: isExcluido ? 'italic' : 'normal' }}>
                                    {truncarNomeArquivo(anexo.nome)}
                                </AnexoNome>
                                <AnexoTamanho>{anexo.tamanho}</AnexoTamanho>
                            </AnexoInfo>
                            {isExcluido ? (
                                <div style={{
                                    padding: '2px 8px',
                                    borderRadius: '12px',
                                    border: '1px solid rgba(239, 68, 68, 0.3)',
                                    fontSize: '10px',
                                    fontWeight: 500,
                                    color: 'var(--cef4444)',
                                    whiteSpace: 'nowrap'
                                }}>
                                    Removido
                                </div>
                            ) : (
                                onNavigateToFile && anexo.id && (
                                    <AnexoLinkButton
                                        type="button"
                                        onClick={() => handleClick(anexo.id!)}
                                    >
                                        <ExternalLink />
                                    </AnexoLinkButton>
                                )
                            )}
                        </AnexoItem>
                    );
                })}
            </div>
        </div>
    );
}

